export default "__VITE_ASSET__Cl2d9619__"